const initialState = {
  organizationListContext: [],
  organogramListContext: [],
  userListContext: [],
  roleListContext: [],
  groupListContext: [],
  employeeListContext: [],
  locationListContext: [],
  departmentListContext: [],
  productListContext: [],
  designationListContext: [],
  lookupListContext: [],
  enumListContext: [],
  componentListContext: [],
  manufacturerListContext: [],
  serviceAssignmentListContext: [],
  blockListContext: [],
  allBlockListContext: [],
};

export default initialState;
